import Vue from 'vue'

// Docs:: https://logaretm.github.io/vee-validate/guide/rules.html#rules
import {ValidationObserver, ValidationProvider, extend} from 'vee-validate'
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/en.json';

Object.keys(rules).forEach(rule => {
  extend(rule, {
  	...rules[rule],
  	message: messages[rule]
  });
});

extend('alpha_num_specialcase', (value) => {
	if(/^(?=.*\d)(?=.*[A-Z]).+$/.test(value))
		return true

	return 'The {_field_} must have 1 uppercase and number.'
});
extend('either_min_value', {
  validate(value, {min, other_val}) {
    return parseInt(value) >= parseInt(min)||parseInt(other_val) >= parseInt(min)
  },
  params: ['min', 'other_val'],
  message: 'The {_field_} and other field must be more than {min}.'
});
extend('max_arr_length', {
	validate(value, {max}) {
		if(value.length <= parseInt(max))
			return true

		return 'The {_field_} must not exceed to '+max+'.'
	},
	params: ['max']
});
extend('max_min_length', {
	validate(value, {min}) {
		if(value.length >= parseInt(min))
			return true

		return 'The {_field_} must not exceed to '+min+'.'
	},
	params: ['min']
});

extend('unique_permission_code', {
	/**
	 * [validate description]
	 * @param  {[type]} value           [description]
	 * @param  {[type]} options.skip_id [description]
	 * @return {[type]}                 [description]
	 */
	validate(value, {skip_id}) {
		return Vue.http.post('permissions/unique-code', {code: value, id: skip_id||0})
			.then(response => {
				if(!response.data) {
					return 'The {_field_} is not unique'
				}
				return true
			})
	},

	params: ['skip_id']
})

extend('unique_username', {
	/**
	 * [validate description]
	 * @param  {[type]} value [description]
	 * @return {[type]}       [description]
	 */
	validate(value) {
		return Vue.http.post('username-unique', {username: value})
			.then(response => {
				if(!response.data) {
					return 'The {_field_} is not unique'
				}
				return true
			})
	}
})
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);